module.exports = __webpack_public_path__ + "static/battle_11-23e0718e368d8920b2bd5e19795621f2.jpg";